module.exports = __webpack_public_path__ + "static/img/vipSuccess.b64041e0.png";